"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPageMusicLinksModuleLayouts = exports.SetPageMusicLinkServices = void 0;
exports.SetPageMusicLinkServices = [
    "Spotify",
    "Apple_Music",
    "Amazon_Music",
    "Deezer",
    "YouTube",
    "Tidal",
    "Pandora",
    "Bandcamp",
];
exports.SetPageMusicLinksModuleLayouts = [
    "card-swiper",
    "image-right",
    "image-left",
];
//# sourceMappingURL=MusicLinks.js.map